import React from 'react';
import Heading from './common/Heading';
import Input from '../assets/images/input.svg';
import Output from '../assets/images/output.svg';
import Financial from '../assets/images/financial.svg';
import Advisory from '../assets/images/advisory.svg';

import '../styles/Services.css';
import { INPUT, INPUT_DESCRIPTION, INPUT_FEATURE_1, INPUT_FEATURE_2, INPUT_FEATURE_3, INPUT_FEATURE_4, INPUT_FEATURE_5, FINANCIAL_DESCRIPTION, FINANCIAL, FINANCIAL_FEATURE_1, FINANCIAL_FEATURE_2, CROP_ADVISORY, CROP_ADVISORY_FEATURE_1, CROP_ADVISORY_FEATURE_2, CROP_ADVISORY_FEATURE_3, CROP_ADVISORY_FEATURE_4, CROP_ADVISORY_FEATURE_5, OUTPUT_FEATURE_1, OUTPUT_FEATURE_2, OUTPUT_FEATURE_3, OUTPUT_DESCRIPTION, OUTPUT, CROP_ADVISORY_DESCRIPTION } from '../data/navbar/menu';
import { useTranslation } from 'react-i18next';
import { SERVICES_SUBTITLE, SERVICES_TITLE } from '../data/i18n/services';
import JumboContainer from './common/JumboContainer';

const serviceOfferings = [
  { 
    image: Input,
    title: INPUT,
    description: INPUT_DESCRIPTION,
    features: [
      INPUT_FEATURE_1,
      INPUT_FEATURE_2,
      INPUT_FEATURE_3,
      INPUT_FEATURE_4,
      INPUT_FEATURE_5
    ]
  },
  { 
    image: Output,
    title: OUTPUT,
    description: OUTPUT_DESCRIPTION,
    features: [
      OUTPUT_FEATURE_1,
      OUTPUT_FEATURE_2,
      OUTPUT_FEATURE_3
    ]
  },
  { 
    image: Advisory,
    title: CROP_ADVISORY,
    description: CROP_ADVISORY_DESCRIPTION,
    features: [
      CROP_ADVISORY_FEATURE_1,
      CROP_ADVISORY_FEATURE_2,
      CROP_ADVISORY_FEATURE_3,
      CROP_ADVISORY_FEATURE_4,
      CROP_ADVISORY_FEATURE_5
    ]
  },
  { 
    image: Financial,
    title: FINANCIAL,
    description: FINANCIAL_DESCRIPTION,
    features: [
      FINANCIAL_FEATURE_1,
      FINANCIAL_FEATURE_2
    ]
  }
]

const Services = () => {

  const {t} = useTranslation();

  return(
    <JumboContainer id="services">
        <Heading title={t(SERVICES_TITLE)} subtitle={t(SERVICES_SUBTITLE)}/>

        <div class="service-container">
          { serviceOfferings.map((service, index) => 
              <div class={index %2 === 0 ? "service" : "service_reverse"}>
                <img
                  class="service-image"
                  src={service.image}
                  alt={t(service.title)}
                />

                <div class="service-detail">
                  <h3 class="service-title">{t(service.title)}</h3>
                  <h5 class="service-subtitle">{t(service.description)}</h5>

                  <div>
                  {
                    service.features.map(feature =>
                      <p class="service-feature">{t(feature)}</p>
                    )
                  }
                  </div>
                </div>
              </div>
            )
          }
        </div>
    </JumboContainer>
  );
}

export default Services;